/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TransactionResponseDto } from '../../models/transaction-response-dto';

export interface TransactionsControllerGetTransactionById$Params {
  id: string;
}

export function transactionsControllerGetTransactionById(http: HttpClient, rootUrl: string, params: TransactionsControllerGetTransactionById$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionResponseDto>> {
  const rb = new RequestBuilder(rootUrl, transactionsControllerGetTransactionById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionResponseDto>;
    })
  );
}

transactionsControllerGetTransactionById.PATH = '/keus-payments/transactions/{id}';
